import React from 'react';
import { Box, Typography } from '@mui/material';
import ReviewIcon from 'assets/images/riviewdicon.svg';
import { formatCurrency } from 'utils';
import type { TileBadge } from '../types';

export function VarianceBadge({ variance }: { variance: number }) {
  const isMatched = variance === 0;
  const label: TileBadge = isMatched ? 'MATCHED' : variance > 0 ? 'SURPLUS' : 'DEFICIT';
  const className = isMatched ? 'matched-badge' : variance > 0 ? 'surplus-badge' : 'deficit-badge';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
      <Box className={className}>{label}</Box>
      {!isMatched ? (
        <Typography sx={{ color: variance > 0 ? '#0000FF' : '#FF0000', fontSize: '22px', fontWeight: 700 }}>
          {formatCurrency(variance)}
        </Typography>
      ) : (
        <img src={ReviewIcon} alt="Matched" className="review-icon" style={{ width: '32px', height: '32px' }} />
      )}
    </Box>
  );
}

